/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EventOnlineView_onlineEvent$ref = any;
type FaceMediaList_faceMedia$ref = any;
type FaceMediaList_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventFaceSearchPage_viewer$ref: FragmentReference;
declare export opaque type EventFaceSearchPage_viewer$fragmentType: EventFaceSearchPage_viewer$ref;
export type EventFaceSearchPage_viewer = {|
  +event: ?{|
    +id: string,
    +sgId: ?number,
    +gps: ?boolean,
    +hostResultUrl: ?string,
    +participant?: ?{|
      +media: ?{|
        +mediaInfo: ?{|
          +count: ?number
        |}
      |},
      +startnumber: ?string,
    |},
    +searchMediaByFace: ?{|
      +mediaInfo: ?{|
        +count: ?number
      |},
      +$fragmentRefs: FaceMediaList_faceMedia$ref,
    |},
    +secondFactorType: ?{|
      +type: ?string
    |},
    +searchByFace: ?boolean,
    +searchByFaceAsFeature: ?boolean,
    +smartSearch: ?boolean,
    +state: ?string,
    +$fragmentRefs: EventOnlineView_onlineEvent$ref & FaceMediaList_offer$ref,
  |},
  +$refType: EventFaceSearchPage_viewer$ref,
|};
export type EventFaceSearchPage_viewer$data = EventFaceSearchPage_viewer;
export type EventFaceSearchPage_viewer$key = {
  +$data?: EventFaceSearchPage_viewer$data,
  +$fragmentRefs: EventFaceSearchPage_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "startnumber",
  "variableName": "startnumber"
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "count",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "EventFaceSearchPage_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "eventId",
      "type": "ID!"
    },
    {
      "kind": "RootArgument",
      "name": "language",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "startnumber",
      "type": "ID!"
    },
    {
      "kind": "RootArgument",
      "name": "secondFactor",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "noStartnumber",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "faceStartnumber",
      "type": "ID!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "event",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "eventId"
        },
        {
          "kind": "Variable",
          "name": "language",
          "variableName": "language"
        }
      ],
      "concreteType": "Event",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sgId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "gps",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hostResultUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "searchMediaByFace",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "face",
              "variableName": "faceStartnumber"
            },
            (v0/*: any*/)
          ],
          "concreteType": "ExtendedMediaConnection",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "FaceMediaList_faceMedia",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "secondFactorType",
          "storageKey": null,
          "args": null,
          "concreteType": "SecondFactorType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchByFace",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchByFaceAsFeature",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "smartSearch",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "state",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "noStartnumber",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "participant",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "secondFactor",
                  "variableName": "secondFactor"
                },
                (v0/*: any*/)
              ],
              "concreteType": "Participant",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "media",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ExtendedMediaConnection",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "startnumber",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "EventOnlineView_onlineEvent",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "FaceMediaList_offer",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '03e1708c07d68139600ede7878eacb50';

module.exports = node;
